import React, { Component } from "react";

interface IGameRulesContainer {
    data: {}
}
export const gameRulesContainer: IGameRulesContainer = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "id": "gameRulesMainContainer",
                        "name": "gameRulesMainContainer",
                        "type": "Container",
                        "x": 0,
                        "y": 0,
                        "visible": true,
                        "filterTypes": [],
                        child: [
                            {
                                "name": "backgroundGraphic",
                                "type": "Graphic",
                                "shape": "rectangle",
                                "visible": true,
                                "alpha": 1,
                                "color": "0x131313",
                                "x": 0,
                                "y": 0,
                                "width": 1920,
                                "height": 1080,

                            },
                            {
                                "id": "gameGuideCont_white",
                                "name": "gameGuideCont_white",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": false,
                                "filterTypes": [],
                                child: [
                                    {
                                        "id": "gameGuideText_white",
                                        "name": "gameGuideText_white",
                                        "type": "Text",
                                        "x": 750,
                                        "y": 130,
                                        "width": 500,
                                        "visible": true,
                                        "text": "game-guide_control_heading_game-guide",
                                        "scaleToFit": true,
                                        "anchor": [0.5, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 50,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "controlsCont_white",
                                "name": "controlsCont_white",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                "filterTypes": [],
                                child: [
                                    {
                                        "id": "controlsText_white",
                                        "name": "controlsText_white",
                                        "type": "Text",
                                        "x": 1150,
                                        "y": 130,
                                        "width": 500,
                                        "visible": true,
                                        "text": "menu-title_game-guide_controls",
                                        "scaleToFit": true,
                                        "anchor": [0.5, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 50,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "gameGuideCont_yellow",
                                "name": "gameGuideCont_yellow",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                "filterTypes": [],
                                child: [
                                    {
                                        "id": "gameGuideText_yellow",
                                        "name": "gameGuideText_yellow",
                                        "type": "Text",
                                        "x": 750,
                                        "y": 130,
                                        "width": 500,
                                        "visible": true,
                                        "text": "game-guide_control_heading_game-guide",
                                        "scaleToFit": true,
                                        "anchor": [0.5, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 50,
                                            fontStyle: 'normal',
                                            fill: ['#f59c06'],
                                        },
                                    },
                                    {
                                        "name": "selected_underline",
                                        "image": "selected_underline.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 300,
                                        "height": 4,
                                        "anchor": [0, 0],
                                        "x": 602,
                                        "y": 175,
                                    },
                                ]
                            },

                            {
                                "id": "controlsCont_yellow",
                                "name": "controlsCont_yellow",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": false,
                                "filterTypes": [],
                                child: [
                                    {
                                        "id": "controlsText_yellow",
                                        "name": "controlsText_yellow",
                                        "type": "Text",
                                        "x": 1150,
                                        "y": 130,
                                        "width": 500,
                                        "visible": true,
                                        "text": "menu-title_game-guide_controls",
                                        "scaleToFit": true,
                                        "anchor": [0.5, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 50,
                                            fontStyle: 'normal',
                                            fill: ['#f59c06'],
                                        },
                                    },
                                    {
                                        "name": "selected_underline",
                                        "image": "selected_underline.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 300,
                                        "height": 4,
                                        "anchor": [0, 0],
                                        "x": 1004,
                                        "y": 175,
                                    },
                                ]
                            },

                            {
                                "name": "gameGuideBtn",
                                "type": "Graphic",
                                "shape": "rectangle",
                                "interactive": true,
                                "buttonMode": true,
                                "visible": true,
                                "alpha": 0.01,
                                "color": "0xffffff",
                                "x": 603,
                                "y": 80,
                                "width": 300,
                                "height": 100,

                            },
                            {
                                "name": "controlBtn",
                                "type": "Graphic",
                                "shape": "rectangle",
                                "interactive": true,
                                "buttonMode": true,
                                "visible": true,
                                "alpha": 0.01,
                                "color": "0xffffff",
                                "x": 1008,
                                "y": 80,
                                "width": 300,
                                "height": 100,

                            },

                            {
                                "id": "GameGuideContainer",
                                "name": "GameGuideContainer",
                                "type": "Tag",
                                "class": "",
                                "parentLayer": "specialAnimationLayer",
                                "filterTypes": [],
                                child: []
                            },
                            {
                                "id": "GameControlComponent",
                                "name": "GameControlComponent",
                                "type": "Tag",
                                "class": "",
                                "parentLayer": "specialAnimationLayer",
                                "filterTypes": [],
                                child: []
                            },

                        ]
                    },
                ]
            },

        ],
    }


};

export const GameRulesContainerConfigurationContext = React.createContext(
    {}
);